import CommonActivityType from '../CommonActivityType'

export default class GetActivityTypeResponse {
  activities: CommonActivityType[]

  constructor(data: { activitys: CommonActivityType[] }) {
    this.activities = data.activitys.map((a) => new CommonActivityType(a))
  }
}
